// extracted by css-extract-rspack-plugin
module.exports =  {"root":"DetailsView__root___ilFz5","txfDocumentationWrapper":"DetailsView__txfDocumentationWrapper___CyyVe"};